import React from 'react';
import PropTypes from 'prop-types';
import { TextArea, Button } from 'semantic-ui-react';
import TextareaAutosize from 'react-textarea-autosize';
import { useForm } from '../../hooks';
import { withPopup } from '../../lib/popup';
import { Popup, Input } from '../../lib/custom-ui';
import styles from './EditPayPopup.module.scss';
import api from '../../api';

const EditPayPopup = React.memo(({ id, onUpdate, onClose }) => {
  const [loading, setLoading] = React.useState(false);
  const [data, handleFieldChange, setData] = useForm(() => ({
    promotionAmountAfterDiscount: '',
    remark: '',
  }));

  const handleFieldPriceChange = (e) => {
    const { value } = e.target;

    const regex = /^\d+(\.\d{0,2})?$/;
    if (regex.test(value)) {
      setData((prevData) => ({
        ...prevData,
        promotionAmountAfterDiscount: value,
      }));
    }
  };

  const onSubmit = () => {
    if (data.promotionAmountAfterDiscount === '') {
      return;
    }
    setLoading(true);
    api
      .payUpdateOrder(id, data)
      .then(() => {
        onUpdate();
        onClose();
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      <Popup.Header wide>修改付款金额</Popup.Header>
      <Popup.Content>
        <Input
          placeholder="请输入付款金额"
          fluid
          className={styles.text}
          type="number"
          value={data.promotionAmountAfterDiscount}
          onChange={handleFieldPriceChange}
          name="promotionAmountAfterDiscount"
        />
        <TextArea
          placeholder="请输入备注"
          as={TextareaAutosize}
          spellCheck={false}
          className={styles.field}
          value={data.remark}
          onChange={handleFieldChange}
          name="remark"
        />
        <Button fluid primary onClick={onSubmit} loading={loading} disabled={loading}>
          修改
        </Button>
      </Popup.Content>
    </>
  );
});

EditPayPopup.propTypes = {
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};
export default withPopup(EditPayPopup, {
  style: {
    width: '200px',
  },
});
